import {createTheme} from "@material-ui/core";

const PastelCandy = createTheme({
    palette: {
        primary: {
            main: '#bdb2ff',
            contrastText: '#caffbf'
        },
        background: {
            default: '#caffbf'
        },
        text: {
            primary: '#25439a'
        }
    }
});

export default PastelCandy;